export default class VoyageComputationState {
    constructor(
        id,
        voyageId,
        voyageTheyrId,
        computation,
        stateValue,
        stateTitle,
        progress,
    ) {
        this.id = id
        this.voyageId = voyageId
        this.voyageTheyrId = voyageTheyrId
        this.computation = computation
        this.stateValue = stateValue
        this.stateTitle = stateTitle
        this.progress = progress
    }
}

